export const getIncidentReportQuestions = (state) =>
  state?.incidentReportForm.questions || [];
export const getPrefilledData = (state) =>
  state?.incidentReportForm.prefilledData || {};
export const getIncidentReportFormComplete = (state) =>
  state?.incidentReportForm.isFormComplete;
export const getIncidentDetails = (state) =>
  state?.serviceRequestPayload?.incident?.incidentDetails || [];
